/** QR хэвлэх карт (handoff §2 / прототипын загвар): A6 өнгөт + хар-цагаан, A4-д 4 ба 6 карт. */
export type QrCard = { building: string; unit_number: string; qr_png: string; url?: string };
export type PrintFormat = 'a6' | 'a4x4' | 'a4x6';

function iconSvg(name: string, color: string, size: number, stroke = 2) {
  const sym = document.getElementById(`i-${name}`);
  const inner = sym ? sym.innerHTML : '';
  return `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="${color}" stroke-width="${stroke}" stroke-linecap="round" stroke-linejoin="round">${inner}</svg>`;
}

/** Хэвлэх HTML-ийг угсарна (autoPrint=false бол урьдчилан харахад). */
const fmtPhone = (p: string) => { const d = (p || '').replace(/\D/g, ''); return d.length === 8 ? `${d.slice(0, 4)} ${d.slice(4)}` : p; };

export function buildQrCardsHtml(cards: QrCard[], sohName: string, format: PrintFormat, bw = false, autoPrint = true, sohPhone = ''): string {
  const a6 = format === 'a6', six = format === 'a4x6';
  const green = bw ? '#000' : '#236844', ink = bw ? '#000' : '#1c2b22', muted = bw ? '#000' : '#5c6a61', line = bw ? '#000' : '#e8e5dc';
  const qrSize = a6 ? 240 : format === 'a4x4' ? 190 : 140;
  const numSize = a6 ? 30 : format === 'a4x4' ? 20 : 16;
  const perPage = a6 ? 1 : format === 'a4x4' ? 4 : 6;
  const logo = bw
    ? `<div class="logo logo--bw">${iconSvg('home', '#000', 24)}</div>`
    : `<div class="logo">${iconSvg('home', '#ffd166', 22)}</div>`;

  const card = (c: QrCard) => `
    <div class="card">
      ${bw ? '' : '<div class="stripe"></div>'}
      <div class="head">${logo}<div><div class="k">СӨХ</div><div class="name">${sohName}</div></div></div>
      <div class="sub">Төлбөр · Санал хүсэлт · Холбоо</div>
      <div class="qrbox"><img src="${c.qr_png}" width="${qrSize}" height="${qrSize}" alt="QR" /></div>
      <div class="num">${c.building ? `${c.building} байр · ` : ''}${c.unit_number} тоот</div>
      ${six ? '' : `<div class="guide">
        <div>${iconSvg('scan', green, 24)}<span>Утсаар<br/>уншуул</span></div>
        <div>${iconSvg('wallet', green, 24)}<span>QPay төлбөр</span></div>
        <div>${iconSvg('message', green, 24)}<span>Санал хүсэлт</span></div></div>`}
      <div class="foot">${sohPhone ? `${iconSvg('call', muted, 12)} <span>СӨХ-ийн захирал: <b>${fmtPhone(sohPhone)}</b></span>` : 'sainhursh.mn · апп, бүртгэл шаардлагагүй'}</div>
    </div>`;

  const pages: string[] = [];
  for (let i = 0; i < cards.length; i += perPage) pages.push(`<section class="page">${cards.slice(i, i + perPage).map(card).join('')}</section>`);

  const css = `
    @page { size: ${a6 ? 'A6' : 'A4'}; margin: 0; }
    * { box-sizing: border-box; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    body { margin: 0; font-family: 'Golos Text', system-ui, sans-serif; color: ${ink}; background: #fff; }
    .page { width: ${a6 ? '105mm' : '210mm'}; height: ${a6 ? '148mm' : '297mm'}; padding: ${a6 ? '0' : '24px'};
      display: grid; grid-template-columns: repeat(${a6 ? 1 : 2}, 1fr); gap: 12px; page-break-after: always; align-content: start; }
    .card { position: relative; overflow: hidden; background: ${bw ? '#fff' : '#fbfaf6'};
      border: ${bw ? '2px solid #000' : (a6 ? `1px solid ${line}` : '1px dashed #9aa39d')}; border-radius: ${bw ? 0 : (a6 ? 12 : 8)}px;
      padding: ${a6 ? '34px 28px 24px' : '16px'}; text-align: center; display: flex; flex-direction: column; align-items: center; gap: ${a6 ? 12 : 6}px;
      ${a6 ? 'width:105mm;height:148mm;' : ''} }
    .stripe { position: absolute; top: 0; left: 0; right: 0; height: 10px; background: linear-gradient(135deg,#2f7d52,#236844); }
    .head { display: flex; align-items: center; gap: 12px; text-align: left; }
    .logo { width: ${a6 ? 52 : 40}px; height: ${a6 ? 52 : 40}px; border-radius: 12px; background: linear-gradient(135deg,#2f7d52,#236844); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
    .logo--bw { background: #fff; border: 2.5px solid #000; }
    .k { font-size: ${six ? 10 : 12}px; color: ${muted}; letter-spacing: .06em; text-transform: uppercase; }
    .name { font-size: ${six ? 13 : a6 ? 18 : 15}px; font-weight: 700; line-height: 1.15; }
    .sub { font-size: ${six ? 11 : 13}px; color: ${muted}; }
    .qrbox { background: #fff; padding: 16px; border-radius: ${bw ? 0 : 12}px; border: 1px solid ${line}; line-height: 0; }
    .num { font-size: ${numSize}px; font-weight: 800; margin-top: 2px; letter-spacing: -.01em; }
    .guide { display: flex; gap: ${a6 ? 34 : 18}px; justify-content: center; margin-top: 2px; }
    .guide div { display: flex; flex-direction: column; align-items: center; gap: 6px; font-size: ${a6 ? 12 : 11}px; color: ${ink}; line-height: 1.2; min-width: 70px; }
    .foot { font-size: ${six ? 10 : 11}px; color: ${muted}; margin-top: auto; display: flex; align-items: center; gap: 5px; } .foot b { color: ${ink}; font-weight: 700; }
  `;
  return `<!doctype html><html lang="mn"><head><meta charset="utf-8"><title>QR карт — ${sohName}</title>
    <link href="https://fonts.googleapis.com/css2?family=Golos+Text:wght@400;700;800&display=swap" rel="stylesheet"><style>${css}</style></head>
    <body>${pages.join('')}${autoPrint ? '<script>window.onload=function(){setTimeout(function(){window.print()},400)}</script>' : ''}</body></html>`;
}

export function printQrCards(cards: QrCard[], sohName: string, format: PrintFormat, bw = false, sohPhone = '') {
  const w = window.open('', '_blank');
  if (!w) return false;
  w.document.write(buildQrCardsHtml(cards, sohName, format, bw, true, sohPhone));
  w.document.close();
  return true;
}
